import { deleteCookie } from 'cookies-next';

export const removeSocialLoginDataCookie = (): void => {
    deleteCookie('registrationDataCookie', { path: '/' });
};
